import { TabsComponent } from "../components/tabs.component";
class OurWorkPage {
    constructor() {
        this.ourWorkTabsId = 'tabsContainerId';
        console.log("START OUR WORK PAGE ....");
        this.initPageConfig();
    }
    initPageConfig() {
        // First landing carousel
        const tabsContainer = document.getElementById(this.ourWorkTabsId);
        if (tabsContainer) {
            const ourworkTabs = new TabsComponent(this.ourWorkTabsId);
            ourworkTabs.onInit();
        }
    }
}
window.addEventListener('load', function () {
    new OurWorkPage();
});
